import moment from "antd/node_modules/moment";
import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { OrgStore } from "./OrgStore";

export class OrgFundsStore {
  rootStore: OrgStore;
  loading = false;

  filter: any = {
    page: 0,
    size: 20,
    orgId: "",
    funOrgId: "",
  };

  sortedInfo = { columnKey: "start", order: "descend" };

  data = {
    total: 0,
    items: [],
  };

  constructor(rootStore: OrgStore) {
    makeAutoObservable(this, {
      rootStore: false,
      pagination: computed,
    });
    this.rootStore = rootStore;
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    let period: string[] = [];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, period, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    console.log("query", params);
    const funOrgId = params.get("funOrgId") || "";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "20");
    this.filter = { orgId: this.filter.orgId, funOrgId, page, size };
    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { orgId, funOrgId, page, size } = this.filter;

    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : [];

    const filter: any = {
      orgId,
      funOrgId,
      page,
      size,
      sorts,
    };

    Api.fr
      .fundraisings(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.fundraisers;
        });
      })
      .finally(() => (this.loading = false));
  }
}
